import { createAction, props } from "@ngrx/store";
import { PracticeFeeDto } from "../../../../core/models/http/treatment/practice-fee-dto";

export const loadSuccess = createAction(
  "[PracticeFee API] Load Success",
  props<{ practiceFees: PracticeFeeDto[] }>()
);
